<template lang="pug">
.container.is-fluid
    .columns
        .column.is-narrow
            p.title.t-1 Home
    .columns
        .column.is-one-fifth
            Weather.t-1
        .column.is-one-fifth
            APPoll.t-1
        .column.is-one-fifth
            NextEvent.t-1
            NextGame.t-1
        
</template>

<script>
import Weather from "@/components/Weather.vue";
import APPoll from "@/components/APPoll.vue";
import NextEvent from "@/components/NextEvent.vue";
import NextGame from "@/components/NextGame.vue";

export default {
  name: "Home",

  title: "Home",

  components: {
    Weather,
    APPoll,
    NextEvent,
    NextGame
  }
};
</script>
